/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class ParentSelectApi {
  async Find(viewState : sis.ViewState, search : string) : Promise<Array<sis.ParentRecord>> {
    return await componentApi.call('sis', 'sis-parent-select', 'ParentSelectApi', 'Find', {
      viewState,
      search,
    });
  }
}
export default new ParentSelectApi()
